import Title from "../Title";
import PersonBlock from "../PersonBlock";
import Link from "next/link";

export default function SectionPersonBlock({
  video,
  name,
  description,
  title,
  body,
  link,
  image,
  reversed = false,
}) {
  return (
    <PersonBlock
      video={video}
      name={name}
      description={description}
      className="py-8 md:py-24"
      image={image}
      reversed={reversed}
      link={link}
    >
      <div className="flex flex-col gap-8 py-0 md:py-6">
        {title && (
          <header>
            <Title className="max-w-[16ch]">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </Title>
          </header>
        )}
        <p className="text-base md:text-lg leading-loose md:leading-[2] max-w-[455px]">
          <span dangerouslySetInnerHTML={{ __html: body }} />
        </p>
        {link && (
          <div>
            <Link href={link.href} className="text-2xl font-semibold draw-line">
              {link.label}
            </Link>
          </div>
        )}
      </div>
    </PersonBlock>
  );
}
